<div style="min-height: 300px;">
  <div class="cardInner">
    @if (dynamicsInitialized) {
      <div>
        <dynamic-form [fields]="uiConfigInit" (submit)="submit($event)">
        </dynamic-form>
      </div>
    }
  </div>
  <br/>
  @if (isHostDevOrLocal) {
    <div>
      <button (click)="devExportConfig()" mat-button>export config</button>
    </div>
  }
</div>

